import React from 'react';
import {useTranslation} from 'react-i18next';

import {getImageUrl} from '../../../finance/utils/get-image-url';
import withSideModal from '../../euro-2020/hocs/with-side-modal';
import {getUsefulMaterialsMock} from '../constants/useful-materials-mock';

import styles from './widget-useful-materials.module.css';

const WidgetUsefulMaterials = ({
  toggleSideModal
}) => {
  const {t} = useTranslation();

  return (
    <>
      <div className={styles.wrapper}>
        <h2 className={styles.title}>{t('fifa2022.useFullMaterialsWidget.widgetTitle')}</h2>
        <div className={styles.list}>
          {getUsefulMaterialsMock(t).map(mockItem => (
            <div key={mockItem.linkUrl} className={styles.item}>
              <img
                className={styles.icon}
                src={getImageUrl(`fifa2022/${mockItem.iconName}.svg`)}
                alt=""
                width="28"
                height="28"
              />
              <div className={styles.content}>
                <p>{mockItem.previewText}</p>
                <div
                  className={styles.link}
                  onClick={() => toggleSideModal({
                    isOpen: true,
                    renderContent: () => <mockItem.modalName />
                  })}
                >
                  {t('fifa2022.useFullMaterialsWidget.snippetButtonText')}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default withSideModal(WidgetUsefulMaterials);
